import WebFontLoader from 'webfontloader'

// async load fonts
WebFontLoader.load({
  google: {
    families: [
      'Playfair+Display:400,500,600,500italic&display=swap',
      'Inter:300,400,500,600,700&display=swap',
    ],
  },
})
